/**
 * Created by tomers on 3/1/2015.
 */
define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var DefaultAgentStatusEditController = require("personalization-web-agent-controllers/DefaultAgentStatusEditController");
    var AwayReasonsEditController = require("personalization-web-agent-controllers/AwayReasonsEditController");

    var FEATURES_TO_EDIT = {
        DEFAULT_LOGIN_STATUS: "defaultLoginStatus",
        AWAY_REASONS: "awayReasons"
    };

    var FEATURES_CONTROLLER_MAP = {};
    FEATURES_CONTROLLER_MAP[FEATURES_TO_EDIT.DEFAULT_LOGIN_STATUS] = DefaultAgentStatusEditController;
    FEATURES_CONTROLLER_MAP[FEATURES_TO_EDIT.AWAY_REASONS] = AwayReasonsEditController;


    var AgentStateEditController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        AgentStateEditController = BaseFeatureController.extend({
            initialize: function(options) {
                this._initialize(options);
            },


            getEditView: function() {
                return this._getEditView();
            },


            _initialize: function (options) {
                LEPersonalization.logger.info("initializing", "AgentStateEditController:_initialize");

                this.controllerOptions = options;
                this.controller = new FEATURES_CONTROLLER_MAP[this.controllerOptions.featureToEdit](this.controllerOptions);
            },

            _getEditView: function () {
                return this.controller.getEditView();
            }
        });
    });

    AgentStateEditController.FEATURES_TO_EDIT = FEATURES_TO_EDIT;

    return AgentStateEditController;

});
